import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

import withMarketTranslations from "../../../../../hocs/withMarketTranslations";
import withTranslations from "../../../../../hocs/withTranslations";
import { useMediaMonitorPagination } from "../../../../../lib/MediaMonitor/useMediaMonitorPagination";
import { getAuthToken } from "../../../../../redux/modules/auth/login/selector";
import Loader from "../../Loader";
import MediaMonitor from "../../MediaMonitor";

const MediaMonitorWrapper = ({ locale, market, ticker, marketTranslations }) => {
  const authToken = useSelector(getAuthToken);
  const {
    data,
    loading,
    loadingMore,
    loadMoreMediaMonitor,
    resolvedMarket
  } = useMediaMonitorPagination({
    market,
    ticker,
    locale,
    authToken,
    marketTranslations
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <MediaMonitor
      ticker={ticker}
      market={resolvedMarket}
      data={data}
      mediaMonitorEntriesLoading={loadingMore}
      loadMoreMediaMonitor={loadMoreMediaMonitor}
    />
  );
};

MediaMonitorWrapper.propTypes = {
  locale: PropTypes.string,
  market: PropTypes.string,
  ticker: PropTypes.string,
  marketTranslations: PropTypes.object
};

export default withTranslations(withMarketTranslations(MediaMonitorWrapper));
